"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const functions_1 = require("../../functions");
function propertyDefinition(pvs) {
    const steamPressures = (0, functions_1.getSteamPressures)(pvs);
    return [
        ...steamPressures.map((_, i) => ({
            sort_no: i,
            name: (0, functions_1.steamPressureName)(i),
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("stepproperty=0"),
            value: [],
            fieldName: functions_1.steamPressurePrefix
        }))
    ];
}
//# sourceMappingURL=pressures-definition.js.map